import * as tslib_1 from "tslib";
import { ElementRef } from '@angular/core';
import { ItmAbstractControl } from '../itm-abstract-control';
var ItmCheckboxComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ItmCheckboxComponent, _super);
    function ItmCheckboxComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.labelBefore = false;
        _this.cssClassLabel = "ml-2";
        return _this;
    }
    ItmCheckboxComponent.prototype.getControlRef = function () {
        return this.controlRef;
    };
    return ItmCheckboxComponent;
}(ItmAbstractControl));
export { ItmCheckboxComponent };
